import {phoneMask, phoneValidator, removeMask} from '../../../utils';
import {getNextPartnerQuestion} from '../flowPartners/flowPartners';

export const informPartnerPh = (inputValue) => {
  const valueMessage = removeMask(inputValue);
  return phoneValidator(valueMessage);
};

export const setPartnerPhone = (
  ecState,
  partnerSel,
  partnerVd,
  partnerPh,
  idQuestion,
  quizPartners,
  partnersTypeList
) => {
  let partners = ecState.partners.map((partner) => {
    if (partner.id === partnerSel.id) {
      return {
        ...partner,
        phone: partnerVd.phoneNumber
      };
    }

    return partner;
  });

  let nextQuestion = getNextPartnerQuestion(
    idQuestion,
    quizPartners,
    partners,
    partnerSel,
    partnersTypeList
  );

  let messages = [
    {
      text: phoneMask(partnerVd.phoneNumber),
      type: 'response-sent'
    }
  ];

  messages.push(...nextQuestion.messages);

  return {
    messages,
    partners,
    partnerPh,
    nextPartner: nextQuestion.partner,
    changePartner: nextQuestion.nextPartner,
    responseType: nextQuestion.responseTypeChange,
    partnersComplete: nextQuestion.partnersComplete,
    partnersTypeList: nextQuestion.partnersTypeList
  };
};
